import { createSlice } from "@reduxjs/toolkit";

import type { ISO8601Datetime } from "@app/types/napi-v2";
import type { NapiPurchaseCancellation } from "@app/types/napi-v2-cancellation-types";
import type { NapiV2PurchaseDetails } from "@app/types/napi-v2-purchase-types";

import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

type PurchaseState = NapiV2PurchaseDetails | null;

const updatePurchaseCancellationStateReducer: CaseReducer<
  PurchaseState,
  PayloadAction<NapiPurchaseCancellation>
> = (state, { payload }) => {
  if (!state) {
    return null;
  }

  if (!state.cancellation) {
    state.cancellation = {
      created_at: new Date().toISOString() as ISO8601Datetime,
      ...payload
    };
  } else {
    state.cancellation = {
      ...state.cancellation,
      ...payload
    };
  }
};

const purchase = createSlice({
  name: "purchase",
  initialState: null as PurchaseState,
  reducers: {
    updatePurchaseCancellationState: updatePurchaseCancellationStateReducer
  }
});

export const { updatePurchaseCancellationState } = purchase.actions;
export default purchase.reducer;
